import { getCompanyConfigOld } from 'lib/api/company';
import { expressGetCompanyConfig } from 'lib/api/express/company';

import { ConfirmingRequestForCreation, RequestConfiguration } from '../types';

export const getRestrictions = async (
  user: any,
  dispatch: any,
  setRequestConfiguration: (requestConfiguration: RequestConfiguration) => void,
  setRequestForCreation: (
    requestForCreation: ConfirmingRequestForCreation,
  ) => void,
  setCanForcePaymentDate: any,
  setMinimumDays: any,
  setMaximumDays: any,
  requestConfiguration: any,
  requestForCreation: any,
) => {
  let system_operations_forcePaymentDate,
    system_operations_minimunDays,
    pruffConnect_operations_uploadPdfMandatory;
  let system_accounting_expensesHasIva,
    fixedArrearRateResponse,
    factoring_request_edit_arrear_rate,
    system_operations_maximumDays;
  let system_confirming_default_exchange_days;
  if (user?.express) {
    if (!user.clientId) {
      return {
        system_operations_forcePaymentDate,
        system_operations_minimunDays,
        pruffConnect_operations_uploadPdfMandatory,
      };
    }
    ({
      system_operations_forcePaymentDate,
      system_operations_minimunDays,
      pruffConnect_operations_uploadPdfMandatory,
      system_accounting_expensesHasIva,
      fixedArrearRateResponse,
      factoring_request_edit_arrear_rate,
      system_confirming_default_exchange_days,
    } = await expressGetCompanyConfig(dispatch, user.clientId, [
      'system_operations_forcePaymentDate',
      'system_operations_minimunDays',
      'pruffConnect_operations_uploadPdfMandatory',
      'system_accounting_expensesHasIva',
      'fixed-arrear-rate-confirmingRequest',
      'factoring_request_edit_arrear_rate',
      'system_operations_maximumDays',
      'system_confirming_default_exchange_days',
    ]));
  } else {
    const config = await getCompanyConfigOld(
      dispatch,
      'system_confirming_default_exchange_days,fixed-arrear-rate-confirmingRequest,system_operations_maximumDays,factoring_request_edit_arrear_rate,system_accounting_expensesHasIva,system_operations_forcePaymentDate,system_operations_minimunDays,pruffConnect_operations_uploadPdfMandatory,system_operations_confirming_maximumDays',
    );

    system_operations_forcePaymentDate =
      config.system_operations_forcePaymentDate;
    system_operations_minimunDays = config.system_operations_minimunDays;
    pruffConnect_operations_uploadPdfMandatory =
      config.pruffConnect_operations_uploadPdfMandatory;
    system_accounting_expensesHasIva = config.system_accounting_expensesHasIva;
    fixedArrearRateResponse = config['fixed-arrear-rate-confirmingRequest'];
    factoring_request_edit_arrear_rate =
      config.factoring_request_edit_arrear_rate;
    system_operations_maximumDays =
      config.system_operations_confirming_maximumDays;
    system_confirming_default_exchange_days =
      config.system_confirming_default_exchange_days;
  }
  const expensesHasIVA = system_accounting_expensesHasIva === '1';
  const fixedArrearRate = fixedArrearRateResponse
    ? parseFloat(fixedArrearRateResponse)
    : undefined;
  setRequestConfiguration({
    ...requestConfiguration,
    expensesHasIVA,
    fixedArrearRate: fixedArrearRate
      ? factoring_request_edit_arrear_rate
        ? false
        : true
      : false,
    arrearRate: fixedArrearRate ? fixedArrearRate : 0,
    exchangeDays: system_confirming_default_exchange_days
      ? Number(system_confirming_default_exchange_days)
      : 0,
  });
  setRequestForCreation({
    ...requestForCreation,
    expensesHasIVA,
    arrearRate: fixedArrearRate ? fixedArrearRate : 0,
    exchangeDays: system_confirming_default_exchange_days
      ? Number(system_confirming_default_exchange_days)
      : 0,
  });
  setCanForcePaymentDate(Number(system_operations_forcePaymentDate) === 1);
  if (system_operations_minimunDays)
    setMinimumDays(Number(system_operations_minimunDays));
  if (system_operations_maximumDays)
    setMaximumDays(Number(system_operations_maximumDays));
  return {
    system_operations_forcePaymentDate,
    system_operations_minimunDays,
    pruffConnect_operations_uploadPdfMandatory,
  };
};
